interface PageAvailability {
  mpvId: string
  availability?: boolean
}

export class PageAvailabilityHandler {
  /**
   * Determines if a product page is available
   * @param mpvId - Product MPV ID
   * @param pageAvailabilities - Array of page availability data
   * @param hasExplicitLink - Whether the tile has an explicitly set link
   */
  static isAvailable(
    mpvId: string,
    pageAvailabilities: PageAvailability[],
    hasExplicitLink: boolean
  ): boolean {
    // Explicit links override availability check
    if (hasExplicitLink) return true

    return pageAvailabilities.find((pa) => pa.mpvId === mpvId)?.availability ?? false
  }
}
